export const HISTORY__FETCH = 'HISTORY__FETCH';
export const HISTORY__FETCH_SUCCESS = 'HISTORY__FETCH_SUCCESS';
export const HISTORY__FETCH_FAILURE = 'HISTORY__FETCH_FAILURE';
export const fetch = ({ accessToken }) => ({ type: HISTORY__FETCH, accessToken });
